import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Model from "../Model";
import tw from "tailwind-styled-components";
import {
    CancelBtn,
    InputGroup,
    Label,
    Note,
    SideCancelBtn,
    SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import Config from "../../Config";

const validationSchema = Yup.object({
    roomNumber: Yup.string()
        .min(1, "Room number must be at least 1 character")
        .max(5, "Room number must be at most 5 characters")
        .required("Room number is required"),
});

const EditRoom = ({
    setEditModel,
    selectedData,
    editRoomNumberLoading,
    editRoomNumberMutate,
    activateRoomLoading,
    activateRoomMutate,
    deactivateRoomLoading,
    deactivateRoomMutate,
    setIsExtraBed,
    setSelectedData,
}) => {
    const initialValues = {
        roomNumber: selectedData?.roomNum || "",
        id: selectedData?.id,
    };

    const handleEditSubmit = (values) => {
        editRoomNumberMutate({
            roomId: selectedData.id,
            newRoomNum: values.roomNumber,
        });
    };

    const handleRoomStatus = () => {
        if (selectedData.status === Config.ROOM_STATUS.INACTIVE) {
            activateRoomMutate({
                roomId: selectedData.id
            });
        } else if (selectedData.status === Config.ROOM_STATUS.VACANT) {
            deactivateRoomMutate({
                roomId: selectedData.id
            });;
        }
    };
    const isActivateRoom = selectedData.status === Config.ROOM_STATUS.INACTIVE;
    const buttonText = isActivateRoom ? "Activate Room" : "Deactivate Room";
    const isLoading = isActivateRoom ? activateRoomLoading : deactivateRoomLoading;
    const loadingText = isActivateRoom ? "Activating..." : "Deactivating...";

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setEditModel}
            title="Edit Room"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleEditSubmit}
            >
                {() => (
                    <Form>
                        {/* <InputGroup>
                            <div className="flex justify-between">
                                <Label>Room No.</Label>
                                {selectedData?.beds?.length < 7 && selectedData.status !== Config.ROOM_STATUS.INACTIVE && selectedData.status !== Config.ROOM_STATUS.VACANT &&
                                    <button className="text-primary-color underline" type="button" onClick={() => {
                                        setIsExtraBed(true);
                                        setEditModel(false);
                                    }}>Add Extra Bed</button>}
                            </div>
                            <Field
                                type="text"
                                name="roomNumber"
                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter Room No."
                            />
                            <ErrorMessage
                                name="roomNumber"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </InputGroup>

                        <div className="w-full flex justify-between space-x-6 my-4">
                            <SideCancelBtn onClick={() => setEditModel(false)}>
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn type="submit" disabled={editRoomNumberLoading}>
                                {" "}
                                {editRoomNumberLoading ? "Editing..." : "Edit"}
                            </SubmitBtn>
                        </div> */}

                        <div className="bg-gray-50 border border-gray-100 rounded-md p-5">
                            <div className="flex items-start justify-between mb-4">
                                <div>
                                    <h4 className="text-sm font-semibold text-gray-900">
                                        Room Details
                                    </h4>
                                    <p className="text-xs text-gray-500 mt-1">
                                        Update room no. & manage bed capacity.
                                    </p>
                                </div>

                                {selectedData?.beds?.length < 7 &&
                                    selectedData.status !== Config.ROOM_STATUS.INACTIVE &&
                                    selectedData.status !== Config.ROOM_STATUS.VACANT && (
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setIsExtraBed(true);
                                                setEditModel(false);
                                            }}
                                            className="
                                            flex items-center gap-2
                                            px-3 py-2
                                            rounded-md
                                            border border-primary-color/20
                                            bg-blue-50
                                            text-primary-color
                                            text-sm font-medium
                                            hover:bg-primary-color/10
                                            transition-all
                                        "
                                        >
                                            + Extra Bed
                                        </button>
                                    )}
                            </div>

                            <InputGroup className="mb-0">
                                <Label className="text-xs font-medium text-gray-600 mb-2 block">
                                    Room Number
                                </Label>

                                <Field
                                    type="text"
                                    name="roomNumber"
                                    maxLength={5}
                                    className="
                                        w-full h-12 px-4
                                        bg-white
                                        border border-gray-200
                                        rounded-md
                                        text-gray-900
                                        placeholder:text-gray-400
                                        focus:outline-none
                                        focus:border-primary-color
                                        focus:ring-4 focus:ring-primary-color/10
                                        transition-all
                                    "
                                    
                                    placeholder="e.g.101"
                                />

                                <ErrorMessage
                                    name="roomNumber"
                                    component="div"
                                    className="text-red-500 text-xs mt-2"
                                />
                            </InputGroup>

                            {/* <div className="flex items-center justify-between mt-3 text-xs text-gray-500">
                                <span>
                                    Current Beds: {selectedData?.beds?.length || 0}/7
                                </span>

                                {selectedData?.beds?.length >= 7 && (
                                    <span className="text-amber-600 font-medium">
                                        Maximum capacity reached
                                    </span>
                                )}
                            </div> */}

                            <div className="flex gap-3 mt-5">
                                <button
                                    type="button"
                                    onClick={() => setEditModel(false)}
                                    className="
                                    flex-1 h-11
                                    rounded-md
                                    border border-gray-200
                                    bg-white
                                    text-gray-700
                                    font-medium
                                    hover:bg-gray-50
                                    transition-all
                                "
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    disabled={editRoomNumberLoading}
                                    className="
                                        flex-1 h-11
                                        rounded-md
                                        bg-primary-color
                                        text-white
                                        font-medium
                                        shadow-md
                                        hover:opacity-90
                                        disabled:opacity-50
                                        disabled:cursor-not-allowed
                                    "
                                >
                                    {editRoomNumberLoading ? "Saving..." : "Save Changes"}
                                </button>
                            </div>
                        </div>

                        {/* Deactivate Room */}
                        <div className="mt-4 border-t border-gray-100 pt-4">
                            <div className="mb-3">
                                <h4 className="font-medium text-gray-900">
                                    Room Status
                                </h4>
                                <p className="text-xs text-gray-500">
                                    Only vacant room can be deactivated.
                                </p>
                            </div>

                            <button
                                type="button"
                                onClick={handleRoomStatus}
                                disabled={selectedData.status !== Config.ROOM_STATUS.VACANT && selectedData.status !== Config.ROOM_STATUS.INACTIVE}
                                className={`
                                        w-full h-12 rounded-md font-medium transition-all
                                        ${isActivateRoom
                                        ? "bg-green-50 text-green-700 border border-green-200"
                                        : "bg-red-50 text-red-700 border border-red-200"
                                    }`}
                            >
                                {isLoading ? loadingText : buttonText}
                            </button>
                        </div>

                        {/* <DeactivateRoomBtn
                            type="button"
                            onClick={handleRoomStatus}
                            disabled={selectedData.status !== Config.ROOM_STATUS.VACANT && selectedData.status !== Config.ROOM_STATUS.INACTIVE}
                            className={`w-full border items-center mb-2 h-12 rounded-lg 
                                ${isActivateRoom ? "border-green-500 text-green-500" : "border-red-500 text-red-500"}
                                disabled:opacity-50 disabled:cursor-not-allowed
                            `}
                        >
                            {isLoading ? (
                                loadingText
                            ) : (
                                buttonText
                            )}
                        </DeactivateRoomBtn>
                        <Note>A room must be vacant in order to be deactivate.</Note> */}
                    </Form>
                )}
            </Formik>
        </Model>
    );
};

const SubTitle = tw.p`text-sm md:text-base text-left mb-6 text-gray-700 text-pretty pt-2`;
const DeactivateRoomBtn = tw.button`w-full border border-red-500 items-center mb-2 text-red-500 h-12 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed`;

export default EditRoom;